import { EMPTY } from "./Constants";

export const pagination = (pageCount, pageIndex, setPageIndex,totalItems,pageValue,startIndex,lastIndex) => {
  let pagination = [];
  let pageCountSet = [];
  for (let i = 1; i <= pageCount; i++) {
    pageCountSet.push(i);
  }
  let finalIndexes = [];

  switch (pageCount > 5) {
    case true:
      switch (pageIndex) {
        case 1:
          //if on first page, show from 1-4 and then last page number
          if (pageIndex === 1) {
            finalIndexes = pageCountSet.slice(pageIndex - 1, pageIndex + 2);
            finalIndexes.push(pageCount);
            finalIndexes.splice(finalIndexes.length - 1, 0, "...");
          }
          break;

        //if on last page, show first page and last 4 page numbers
        case pageCountSet[pageCountSet.length - 1]:
          if (pageIndex === pageCountSet[pageCountSet.length - 1]) {
            finalIndexes = pageCountSet.slice(pageIndex - 3, pageIndex);
            finalIndexes.unshift(1);
            finalIndexes.splice(1, 0, "...");
          }
          break;

        //if on second page, show from 2-5 and last page number
        case pageCountSet[1]:
          if (pageIndex === pageCountSet[1]) {
            finalIndexes = pageCountSet.slice(0, pageIndex + 1);
            finalIndexes.push(pageCount);
            finalIndexes.splice(finalIndexes.length - 1, 0, "...");
          }
          break;

        //if on last but one page, show last 5 page numbers
        case pageCountSet[pageCountSet.length - 2]:
          if (pageIndex === pageCountSet[pageCountSet.length - 2]) {
            finalIndexes = pageCountSet.slice(pageIndex - 2, pageIndex + 1);
            finalIndexes.unshift(1);
            finalIndexes.splice(1, 0, "...");
          }
          break;

        default:
          //if numbers in between, show one on each side as well as first and last page numbers
          finalIndexes = pageCountSet.slice(pageIndex - 2, pageIndex + 1);
          finalIndexes.unshift(1);
          finalIndexes.push(pageCount);
          finalIndexes.splice(finalIndexes.length - 1, 0, "...");
          finalIndexes.splice(1, 0, "...");

          break;
      }
      break;

    default:
      for (let i = 1; i <= pageCount; i++) {
        pagination.push(
         <span onClick={() => setPageIndex(i)}class={`${pageIndex === i ? " active" : ""}` }>{i}</span> 
        );
      }
      break;
  }

  finalIndexes.map((index) => {
    pagination.push(
      <>
        {index !== "..." && (<span style={{color:'#1A1A1A'}} onClick={() => setPageIndex(index)}class={`${pageIndex === index ? " active" : ""}` }>{index}</span>)}
        {index === "..." && (<span class="disabled">...</span> )}
      </>
    )
  });

  return(
    <div>
    <div class="paging-wrapper">
    <div class="records-count">
      <span style={{color:'#1A1A1A'}} >{startIndex}-{lastIndex}</span>
      <b style={{color:'#1A1A1A'}} > of </b>
      <span style={{color:'#1A1A1A'}}>{totalItems}</span>
    </div>
    <div class="paging-btns">
      <div class="pagination-count">
        <span style={{color:'#1A1A1A'}} onClick={() => setPageIndex(pageIndex-1)} class={`change-page-btn prev-radius ${pageIndex===1 ? 'disabled':EMPTY}`}>
          <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 192.701 192.701">
            <path d="M29.641,96.345l74.54-75.61c4.704-4.74,4.704-12.439,0-17.179c-4.704-4.74-12.319-4.74-17.011,0l-82.997,84.2
        c-4.511,4.559-4.535,12.608,0,17.191l83.009,84.2c4.692,4.74,12.319,4.74,17.011,0c4.704-4.74,4.704-12.439,0-17.179
        L29.641,96.345z"></path>
            <path d="M113.853,96.345l74.54-75.61c4.704-4.74,4.704-12.439,0-17.179c-4.704-4.74-12.319-4.74-17.011,0l-82.997,84.2
        c-4.511,4.559-4.535,12.608,0,17.191l82.997,84.2c4.704,4.74,12.319,4.74,17.011,0c4.704-4.74,4.704-12.439,0-17.179
        L113.853,96.345z"></path>
          </svg > Prev </span>
          <div>{pagination}</div> <span style={{color:'#1A1A1A'}} onClick={() => setPageIndex(pageIndex+1)}class={`change-page-btn prev-radius ${pageIndex==pageCount ? 'disabled':EMPTY}`}>Next <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 192.689 192.689">
            <path d="M188.527,87.755l-83.009-84.2c-4.692-4.74-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l74.54,75.61
        l-74.54,75.61c-4.704,4.74-4.704,12.439,0,17.179c4.704,4.74,12.319,4.74,17.011,0l82.997-84.2
        C193.05,100.375,193.062,92.327,188.527,87.755z"></path>
            <path d="M104.315,87.755l-82.997-84.2c-4.704-4.74-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l74.528,75.61
        l-74.54,75.61c-4.704,4.74-4.704,12.439,0,17.179s12.319,4.74,17.011,0l82.997-84.2C108.838,100.375,108.85,92.327,104.315,87.755
        z"></path>
          </svg>
        </span>
      </div>
    </div>
  </div>
 </div>)
};
